import { useIonToast } from '@ionic/react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from '@state/store';
import { getIsOnline, setIsOnline } from '@state/system';
import { PluginListenerHandle } from '~capacitor-plugins/core';
import { Network } from '~capacitor-plugins/network';

export default function useNetwork(message: string) {
  const dispatch = useDispatch<AppDispatch>();
  const [present, dismiss] = useIonToast();
  const isOnline = useSelector(getIsOnline);

  useEffect(() => {
    let listener: PluginListenerHandle;

    async function effect() {
      listener = await Network.addListener('networkStatusChange', status => {
        dispatch(setIsOnline(status?.connected ?? false));
      });
    }
    effect();

    return () => {
      if (listener) {
        listener.remove();
      }
    };
  }, [dispatch]);

  useEffect(() => {
    async function effect() {
      if (isOnline) {
        await dismiss();
      } else {
        await present({
          message,
          color: 'dark',
        });
      }
    }
    effect();
  }, [isOnline, present, dismiss, message]);
}
